import "./styles.css";
import {
  AccountEnvironment,
  Page,
  useEnvironment,
  // useAccountAlerts,
} from "@keycloak/keycloak-account-ui";
import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
import { deleteAvatar, token, url } from "./api/methods";
import avatarPlaceholder from "./assets/avatarPlaceholder.svg";

import Uppy from "@uppy/core";
import { Dashboard } from "@uppy/react";
import ImageEditor from "@uppy/image-editor";
import XHR from "@uppy/xhr-upload";

import "@uppy/core/css/style.min.css";
import "@uppy/dashboard/css/style.min.css";
import "@uppy/image-editor/css/style.min.css";

export const Avatar = () => {
  // const { t } = useTranslation();
  // const { addAlert, addError } = useAccountAlerts();
  const context = useEnvironment<AccountEnvironment>();

  const [avatarImg, setImgPreview] = useState<string | undefined>();

  const [uppy] = useState(() => {
    const uppyInstance = new Uppy({
      id: "file-uploader",
      restrictions: {
        maxNumberOfFiles: 1,
        maxFileSize: 1048576,
        allowedFileTypes: [".jpg", ".png", ".jpeg"],
      },
      autoProceed: false,
    });

    uppyInstance.use(ImageEditor, {
      cropperOptions: {
        aspectRatio: undefined,
        viewMode: 1,
      },
      actions: {
        revert: true,
        rotate: true,
        granularRotate: true,
        flip: true,
        zoomIn: true,
        zoomOut: true,
        cropSquare: true,
        cropWidescreen: false,
        cropWidescreenVertical: false,
      },
    });

    (async () => {
      try {
        const accessToken = token(context.keycloak);
        const resultToken = await accessToken();
        uppyInstance.use(XHR, {
          headers: {
            authorization: `Bearer ${resultToken}`,
          },
          endpoint: url(context.environment, "avatar").toString(),
          timeout: 0,
          limit: 6,
          formData: true,
          fieldName: "image",
          getResponseData: (xhr: XMLHttpRequest) => {
            return {
              url: xhr.response.toString(),
            };
          },
        });
      } catch (error) {
        console.error("Failed to set token:", error);
      }
    })();

    return uppyInstance;
  });

  useEffect(() => {
    load();

    const completeHandler = (result: any) => {
      setImgPreview(URL.createObjectURL(result.successful[0].data));
    };

    uppy.on("complete", completeHandler);

    return () => {
      uppy.off("complete", completeHandler);
    };
  }, [uppy]);

  const doneButtonHandler = () => {
    window.location.reload();
  };

  const resetAvatar = async () => {
    setImgPreview(avatarPlaceholder);
    await deleteAvatar(context);
    doneButtonHandler();
  };

  async function load() {
    if (context.keycloak.idTokenParsed?.picture) {
      setImgPreview(context.keycloak.idTokenParsed?.picture);
    } else {
      setImgPreview(avatarPlaceholder);
    }
  }

  return (
    <Page title={"Avatar"} description={"My profile picture"}>
      <div className="avatarUpload">
        <div className="avatarDisplay">
          <div className="currentAvatar">
            <img className="avatarImg" src={avatarImg} />
          </div>
          <div className="userName">
            {context.keycloak.idTokenParsed?.preferred_username
              ? context.keycloak.idTokenParsed?.preferred_username
              : "Current avatar"}
          </div>
          <button className="resetButton" onClick={resetAvatar}>
            Reset
          </button>
        </div>
        <div className="avatarUppy">
          <Dashboard
            className="uppy"
            uppy={uppy}
            height={"50vh"}
            width={"100%"}
            note="Accepted file types: jpg and png. Maximum size per photo: 1MB"
            proudlyDisplayPoweredByUppy={false}
            showLinkToFileUploadResult={false}
            showRemoveButtonAfterComplete={false}
            hideProgressDetails={false}
            doneButtonHandler={doneButtonHandler}
          />
        </div>
      </div>
    </Page>
  );
};
